import script from "./TopNavBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./TopNavBar.vue?vue&type=script&lang=ts&setup=true"

import "./TopNavBar.vue?vue&type=style&index=0&id=3deef7fa&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3deef7fa"]])

export default __exports__